import { render, staticRenderFns } from "./WabidentColorPicker.vue?vue&type=template&id=4957b987"
import script from "./WabidentColorPicker.vue?vue&type=script&lang=js"
export * from "./WabidentColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports